import { Link } from "react-router-dom";
import { Facebook, Twitter, Youtube, Linkedin, Phone, Mail, MapPin, Download } from "lucide-react";
import { Container } from "@/site/ui";

const SOCIAL_ICON = { facebook: Facebook, twitter: Twitter, youtube: Youtube, linkedin: Linkedin };
const QUICK = { "Home": "/", "About Us": "/about", "Testimonials": "/testimonials", "Medical Tourism": "/medical-tourism", "Contact Us": "/contact" };

export default function Footer({ content }) {
  const f = content.footer;
  const c = content.contact;
  return (
    <footer data-testid="site-footer" className="bg-[#0A0A0A] text-white">
      <Container className="py-16 md:py-20">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <p className="text-2xl font-bold tracking-tight">{content.brand.short}</p>
            <p className="mt-1 text-sm text-white/50 italic">{content.brand.tagline}</p>
            <p className="mt-6 text-sm leading-relaxed text-white/60 max-w-xs">{c.company}</p>
            <div className="mt-6 flex items-center gap-3">
              {Object.entries(f.socials || {}).map(([k, url]) => {
                const Icon = SOCIAL_ICON[k];
                if (!Icon) return null;
                return (
                  <a key={k} href={url || "#"} target="_blank" rel="noreferrer" data-testid={`social-${k}`}
                    className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-white/15 text-white/70 transition-colors duration-200 hover:bg-[var(--rgh-primary)] hover:border-[var(--rgh-primary)] hover:text-white">
                    <Icon size={17} />
                  </a>
                );
              })}
            </div>
          </div>

          <div className="lg:col-span-2">
            <h4 className="text-xs font-semibold uppercase tracking-[0.18em] text-white/40">Quick Links</h4>
            <ul className="mt-5 space-y-3">
              {f.quick_links.map((q) => (
                <li key={q}><Link to={QUICK[q] || "/"} className="text-sm text-white/70 hover:text-white transition-colors duration-200">{q}</Link></li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <h4 className="text-xs font-semibold uppercase tracking-[0.18em] text-white/40">Our Products</h4>
            <ul className="mt-5 space-y-3">
              {f.products.map((p) => (
                <li key={p}><Link to="/services" className="text-sm text-white/70 hover:text-white transition-colors duration-200">{p}</Link></li>
              ))}
              <li><Link to="/downloads" className="inline-flex items-center gap-2 text-sm font-medium text-[var(--rgh-primary)] hover:text-white transition-colors duration-200"><Download size={15} /> Downloads</Link></li>
            </ul>
          </div>

          <div className="lg:col-span-3">
            <h4 className="text-xs font-semibold uppercase tracking-[0.18em] text-white/40">Get in touch</h4>
            <ul className="mt-5 space-y-4 text-sm text-white/70">
              <li className="flex items-start gap-3"><Phone size={16} className="mt-0.5 text-[var(--rgh-primary)] shrink-0" /><span>{f.phone}</span></li>
              <li className="flex items-start gap-3"><Mail size={16} className="mt-0.5 text-[var(--rgh-primary)] shrink-0" /><a href={`mailto:${f.email}`} className="hover:text-white">{f.email}</a></li>
              <li className="flex items-start gap-3"><MapPin size={16} className="mt-0.5 text-[var(--rgh-primary)] shrink-0" /><span>{c.address}</span></li>
            </ul>
          </div>
        </div>

        <div className="mt-14 border-t border-white/10 pt-8">
          <h4 className="text-xs font-semibold uppercase tracking-[0.18em] text-white/40">Our Locations</h4>
          <div className="mt-4 flex flex-wrap gap-x-5 gap-y-2">
            {f.locations.map((l) => (
              <span key={l} className="text-xs text-white/45 hover:text-white/80 transition-colors duration-200">{l}</span>
            ))}
          </div>
        </div>

        <div className="mt-12 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/40">
          <p>© {new Date().getFullYear()} {content.brand.name}. All rights reserved.</p>
          <p>Designed to help you live better.</p>
        </div>
      </Container>
    </footer>
  );
}
